var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leak-type-table-cell"},[_c('span',{staticClass:"value",attrs:{"title":_vm.value}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }